<template>
	<div
		v-on="$listeners"
		ref="menu_list_item_container"
		class="list-item-container flex-centerize"
		:class="{ selectable: canChooseItems, focused: isFocused && canChooseItems }"
	>
		<div class="data-table-item width-100 display-flex">
			<div class="display-flex flex-row" v-if="!isTable">
				<div class="display-flex flex-row">
					<SIcon name="column" class="column-icon" />
					<DataTypeIcon class="mr-1" :itemValue="value" />
				</div>
				<div class="key display-flex flex-align-start">
					<div class="px-1" :class="{ 'selectable-key': canChooseItems }" v-html="markSearchString(getCleanHtml(readableKey))" />
				</div>
			</div>
			<div class="value text-ellipsis-2-line display-flex pl-1">
				<!-- recursive representation of list -->
				<DataTableRepresentation
					:input="value"
					v-if="isTable"
					isTableInsideTable
					:listKey="readableKey"
					:nodeUUID="nodeUUID"
					:searchString="searchString"
				/>
				<div v-else-if="value !== null" v-html="markSearchString(getCleanHtml(value))" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { sanitizeHtml } from '@/utils/helpers';
import ParamsService from '@/utils/ParamsService';
import { shouldFormatPropertyKey } from '@/store/modules/auth/getters';
import { markString } from '../DataInput/DataInputMenu/helpers/helpers';

export default {
	name: 'DataTableItem',
	props: {
		itemKey: { type: String },
		htmlKey: { type: String },
		nodeUUID: { type: String },
		isTable: { type: Boolean },
		isFocused: { type: Boolean },
		searchString: { type: String },
		canChooseItems: { type: Boolean },
		value: { type: [Object, Array, String, Number, Boolean] },
	},
	components: { DataTableRepresentation: () => import('./DataTableRepresentation') },
	computed: {
		...mapGetters([shouldFormatPropertyKey.fullPath]),
		readableKey() {
			return ParamsService.formatPropertyKeyToReadable(this.htmlKey, this[shouldFormatPropertyKey.fullPath]);
		},
	},
	methods: {
		markSearchString(str) {
			return markString(this.searchString, str);
		},
		getCleanHtml(dirtyContent) {
			return sanitizeHtml(String(dirtyContent));
		},
	},
	watch: {
		isFocused: {
			handler(newV) {
				newV && this.$emit('scroll-to-element', this.$refs.menu_list_item_container.getBoundingClientRect());
			},
		},
	},
};
</script>
<style lang="scss" scoped>
.list-item-container {
	margin-top: 2px;
	min-height: 25px;
}
.selectable {
	&:hover,
	&.focused {
		cursor: pointer;
		background: var(--insert-data-item-hover-background);
	}
}
.selectable-key {
	background: var(--table-column-background);
	border-radius: 3px;
}
.data-table-item {
	$grey-color: #444e5f;
	$light-grey-color: rgb(53 64 82 / 48%);
	font-size: 12px;
	.column-icon {
		margin-top: 2px;
		margin-right: 2px;
	}
	.data-type-icon {
		margin-right: 2px;
	}
	.key {
		color: var(--primary-font-color);
		border-left: 1px solid rgb(159 164 173 / 30%);
		margin-left: 3px;
		padding: 0px 4px;
		line-height: 16px;
	}
	.value {
		color: $light-grey-color;
		display: inline-block;
		line-height: 16px;
		max-width: 250px;
	}
	.text-ellipsis-2-line {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		white-space: normal;
	}
}
</style>
